import { useEffect, useState } from 'react';

import { ResourceStatusEnum, VersionConfig } from '@/types/schema';

export const usePreviewLabel = (
  initialId?: string,
  status?: ResourceStatusEnum,
  versionConfigs?: VersionConfig[] | null,
) => {
  const [previewId, setPreviewId] = useState<string>();

  useEffect(() => {
    if (!previewId && status) {
      if (status === ResourceStatusEnum.UnpublishedChanges) {
        setPreviewId(
          versionConfigs?.find((item) => item.status === ResourceStatusEnum.Draft)?.rootBlockId!,
        );
      } else {
        setPreviewId(initialId);
      }
    }
  }, [versionConfigs, status, initialId, previewId]);

  return { previewId, setPreviewId };
};

export default usePreviewLabel;
